import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showCurrent: false,
  showNew: false,
  showConfirm: false,
};

const securitySlice = createSlice({
  name: "security",
  initialState,
  reducers: {
    toggleShowCurrent(state) {
      state.showCurrent = !state.showCurrent;
    },
    toggleShowNew(state) {
      state.showNew = !state.showNew;
    },
    toggleShowConfirm(state) {
      state.showConfirm = !state.showConfirm;
    },
  },
});

export const {
  toggleShowCurrent,
  toggleShowNew,
  toggleShowConfirm,
  resetSecurity,
} = securitySlice.actions;

export default securitySlice.reducer;
